import { useQuery } from '@apollo/client';
import { GET_ACTIVITY_ASSIGNMENT } from 'graphql/activityAssignments/queries/getActivityAssignment.gql';

export default function useQueryActivityAssignment(id?: number) {
  return useQuery(GET_ACTIVITY_ASSIGNMENT, {
    skip: !id,
    variables: id
      ? {
          id,
        }
      : undefined,
  });
}
